import {
  FormValidations,
  SetValidationRuleFunction,
  ValidationActionType,
} from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";
import ValidationRule from "features/validation/rules/ValidationRule";

export const processFormValidations = (): FormValidations => {
  return {
    terminationOfExistingContract: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "processFormValidation.terminationOfExistingContract",
    },
    contractExpectedEffectiveDate: {
      required: true,
      type: "OnlyRequired",
    },
  };
};

export const setYesTerminationByUsValidations = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  const prefix = "yesTerminationByUs.";

  setValidationRule(`${prefix}currentSupplierCode`, getRequiredRule(), action);
  setValidationRule(`${prefix}contractDurationTypeCode`, getRequiredRule(), action);
  setValidationRule(`${prefix}terminationSchemeCode`, getRequiredRule(), action);
};

export const setContractEffectiveDateValidation = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  setValidationRule(
    "yesTerminationByUs.contractEffectiveDate",
    getRequiredRule(),
    action
  );
};

export const setNoContractByAnotherValidations = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  setValidationRule(
    "noContractByAnother.currentSupplierType",
    getRequiredRule(),
    action
  );
};

export const setCurrentSupplierValidation = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add",
  prefix: string = "noContractByAnother"
) => {
  setValidationRule(
    `${prefix}.currentSupplierCode`,
    getRequiredRule(),
    action
  );
};

export const setNoPlaceOfDeliveryQuestionsValidations = (
  setValidationRule: SetValidationRuleFunction,
  objectPrefix: string,
  action: ValidationActionType = "add"
) => {
  const rule: FunctionValidationRule = {
    type: "Function",
    validate: (value: any) => value === true || value === false,
    message: "required"
  }

  setValidationRule(`${objectPrefix}.existsConnectionContract`, rule, action);
  setValidationRule(`${objectPrefix}.ownerOfProperty`, rule, action);
};

export const setNoFixedContratDurationSubForms = (
  setValidationRule: SetValidationRuleFunction,
  action: ValidationActionType = "add"
) => {
  setValidationRule(
    "noFixedContratDuration.contractEffectiveDate",
    getRequiredRule(),
    action
  );
};

// PRIVATE
const getRequiredRule = (): ValidationRule => {
  return {
    required: true,
    type: "OnlyRequired",
  };
};
